import { useEffect, useRef } from "react";
import { useLiveTutor } from "../../../hooks/LiveTutorProvider";

interface VideoProps {
	video: {
		src: string;
		title?: string;
	};
}

const Video: React.FC<VideoProps> = ({ video }) => {
	const videoRef = useRef<HTMLVideoElement>(null);
	const { handleChat, setShowContinueButton } = useLiveTutor();

	useEffect(() => {
		handleChat("Watch the video carefully.", false);
	}, []);

	const handleVideoEnd = () => {
		setShowContinueButton(true);
	};

	return (
		<div className="flex flex-col items-center space-y-4 md:space-y-6 max-w-2xl mx-auto p-3 md:p-6 bg-gray-50 rounded-xl shadow-md">
			<h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center">
				{video.title || "Watch the Video"}
			</h2>

			<div className="w-full aspect-video rounded-lg overflow-hidden shadow-lg">
				<video
					ref={videoRef}
					src={video.src}
					className="w-full h-full object-cover"
					controls
					onEnded={handleVideoEnd}
					onError={handleVideoEnd}
					controlsList="nodownload"
					playsInline
				>
					Your browser does not support the video tag.
				</video>
			</div>
		</div>
	);
};

export default Video;
